<script setup lang="ts">
// REQ-CD-P1-CON-01 — Phase 1 grows to five routes behind a shared AppShell
// (header, nav, ModeBadge, BuildIdBadge, skip-to-content, the main landmark).
import AppShell from "@/components/organisms/AppShell.vue";
</script>

<template>
  <AppShell />
</template>
